/**
 * Guía: Impuestos.
 *
 * Contenido derivado del capítulo **17c** del manual: §0 (qué gravan de
 * verdad estos impuestos, que es lo único que hay que entender de la
 * pantalla).
 *
 * La confusión que evita es grande: se cree que aquí se configura el IVA de
 * los platos de los comercios, y no es así — ni el modelo lo permite.
 */

import type { TourFlow } from '../types';

const IMPUESTOS_PATH = '/taxes';

export const c17cImpuestos: TourFlow = {
  id: 'admin.taxes',
  chapter: '17c',
  title: 'Impuestos',
  summary:
    'Qué gravan de verdad estos impuestos, y por qué el IVA de un plato no se configura aquí.',
  href: IMPUESTOS_PATH,
  requiresCountry: true,
  estimatedMin: 2,
  steps: [
    {
      id: 'intro',
      title: 'Gravan lo que cobra 121Pass, no lo que vende la tienda',
      body:
        'Sólo la tarifa de servicio y la comisión que se le retiene al comercio. El IVA de ' +
        'un plato, el impuesto al consumo o el municipal del comercio los maneja cada tienda ' +
        'en su facturación, y la plataforma ni los configura ni los calcula.',
      route: IMPUESTOS_PATH,
    },
    {
      id: 'model-does-not-allow',
      title: 'No es una convención: el modelo no permite otra cosa',
      body:
        'Un impuesto sólo puede aplicarse a esos dos conceptos. No hay forma de crear aquí ' +
        'uno que grave la venta del comercio, así que si alguien lo pide, la respuesta es ' +
        'que ese impuesto vive en su facturación.',
      target: 'admin.taxes.scopeTabs',
      placement: 'bottom',
      optionalTarget: true,
    },
    {
      id: 'per-country',
      title: 'Se configura por país',
      body:
        'Y es uno de los siete requisitos para activarlo. Un país sin impuesto configurado ' +
        'no arranca.',
    },
  ],
};
